var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56786 13.4942C6.12859 14.207 7.00946 14.6663 8 14.6663C8.99055 14.6663 9.87142 14.207 10.4321 13.4942C8.81762 13.713 7.18238 13.713 5.56786 13.4942Z",
    fill: "#06B394"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4994 5.99967V6.46907C12.4994 7.0324 12.6602 7.58312 12.9615 8.05184L13.6998 9.20044C14.3741 10.2496 13.8593 11.6756 12.6864 12.0074C9.61817 12.8753 6.38183 12.8753 3.31357 12.0074C2.1407 11.6756 1.62588 10.2496 2.30024 9.20044L3.03853 8.05184C3.33981 7.58312 3.50058 7.0324 3.50058 6.46907V5.99967C3.50058 3.42234 5.51504 1.33301 8 1.33301C10.485 1.33301 12.4994 3.42235 12.4994 5.99967Z",
    fill: "#06B394"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.ef69799df1a84837def67267cdc07adc.svg";
export { ForwardRef as ReactComponent };